
         <!-- <ngx-spinner [fullScreen]="false" type="ball-clip-rotate-multiple" size="medium">
            <p class="loading">Loading Awesomeness...</p>
       </ngx-spinner>  -->
     

<div class="container-fluid" >
<div class="row">
<div class="col-lg-7  p-0 d-none d-sm-block" >
<img class="w-100 vh-100  "  alt=""
 src="../../../../assets/images/ikram/beside login form 1010 x 601-01.png"
 alt="looginpage"
/>
  
</div>
<div class="col-lg-5  col-sm-12  ">
 
   <div class="container-fluid">
     <div class="row">
       <div class="col-12 p-0 ">
         <div class="login-card" >
           <div>
             
             <div id="Sign-User" class="login-main " >
               <div  class="text-center ">
                 <img src="../../../../assets/images/ikram/above login form 370 X 425-01.png" class="w-100" style="padding: 13%; margin-bottom: -75px;" alt="">
               </div>
               <form
                 class="theme-form needs-validation"
                 [formGroup]="person"
                (ngSubmit)="onSubmit()"
                 novalidate >
               <div class="form-row ">

                 <label class="col-form-label col-12 "><span class="pull-right">اسم المستخدم</span></label>
 
                   <div class="col-12 col-sm-12">
          
                     <input
                   class="form-control"
                   required=""
                   style="direction: rtl;"
                   placeholder="اسم المستخدم"
                   formControlName="userName"
                 />
                   </div>
    
               <div class="col-12 mb-0">
 
                 <label class="col-form-label col-12 mx-0"> <span class="pull-right ">كلمة المرور</span>    </label>
 
                 <div class="form-input position-relative">
 
 
                   <input
                     class="form-control"
                     [type]="changetype? 'password' : 'text' "
                     required=""
                     style="direction: rtl;"
                     placeholder="**************"
                     formControlName="password"
                 
                     />
                     <div class="show-hide  show" (click)="showPassword()" *ngIf="!show"><span class="show text-primary" > </span>
                     </div>
                     <div class="show-hide show" (click)="showPassword()" *ngIf="show"><span class="hide text-primary" > </span>
                     </div>
                 </div>
               </div>
               </div>
               
 
               <div class="form-group mb-0 mt-3">
 
                           <!-- ============================================================================================ -->
                                                        <!-- This is the remember me tag -->
                           <!-- ============================================================================================= -->
                 <button class="btn btn-block w-100"   type="submit" >
                 <label class="col-form-label "> 
                   <span class="w-100">تسجيل دخول</span>  
                 </label>
                 </button>
               </div>
               </form>
               <div style="text-align: center;">
                 <span><br>
                   © EKARM Dashboard {{year}} All Rights Reserved<br> Developed & Powered by <a href="http://www.wecancity.com" target="_blank">
                    wecancity.com
                   </a>
                 </span>
               </div>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>

</div>
</div>

</div>


<!-- <ngx-spinner
[fullScreen]="false"
type="ball-clip-rotate-multiple"
size="medium"
>
<p class="loading">Loading Awesomeness...</p>
</ngx-spinner> -->
